const CONTEXT_REFERENCE_STALE_TIME_MS = 30 * 60 * 1000;

interface RefreshableContextQuery {
    dataUpdatedAt: number;
    refetch: () => Promise<unknown>;
}

function isContextReferenceStale(lastUpdatedAt: number, now = Date.now()): boolean {
    return lastUpdatedAt === 0 || now - lastUpdatedAt >= CONTEXT_REFERENCE_STALE_TIME_MS;
}

async function refreshStaleContextQueries(
    queries: readonly RefreshableContextQuery[],
    now = Date.now()
): Promise<void> {
    await Promise.all(
        queries.map(query =>
            isContextReferenceStale(query.dataUpdatedAt, now)
                ? query.refetch()
                : Promise.resolve()
        )
    );
}

export {
    CONTEXT_REFERENCE_STALE_TIME_MS,
    isContextReferenceStale,
    refreshStaleContextQueries,
};
